<button class="btn btn-close btn-close-attachment" (click)="closeDialog()">
    <pay-icon name="close" class="mod-sm"></pay-icon>
</button>
<pay-dialog-body class="pay-dialog-body">
    <img [src]="config.url" alt="Attachment">
</pay-dialog-body>
<pay-dialog-actions class="pay-dialog-actions">
    <button class="btn btn-link btn-attachment btn-lg" (click)="saveAttachment($event)">
        {{'Common.SaveAttachment'|translate}}
    </button>
</pay-dialog-actions>
